import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { FormLabel } from './FormLabel';
import { FormReadOnly } from './FormReadOnly';

interface IOptionExternal {
  value: string | number;
  children: string;
}

const OptionExternal: React.FC<IOptionExternal> = (props) => {
  return <div>{props.children}</div>;
};

export interface IButtonGroup {
  children?: React.ReactNode;
  name: string;
  onChange?: (arg?: any) => void;
  selectedValue: string | number;
  label: string;
  stacking?: 'horizontal' | 'vertical';
  readonly?: boolean;
}

class ButtonGroup extends React.Component<IButtonGroup, {}> {
  static readonly Option: typeof OptionExternal = OptionExternal;

  render() {
    const { children, label, name, onChange, stacking, readonly, selectedValue } = this.props;

    if (readonly) {
      const selected = React.Children.toArray(children).filter(
        (child: React.ReactElement<IOptionExternal>) => child.props.value === selectedValue,
      )[0] as React.ReactElement<IOptionExternal>;
      return <FormReadOnly label={label} value={selected.props.children} />;
    }

    const newChildren = React.Children.map(
      children,
      (child: React.ReactElement<IOptionExternal>) => {
        const checked = child.props.value === selectedValue;
        return (
          <ToggleButton value={child.props.value} selected={checked}>
            {child.props.children}
          </ToggleButton>
        );
      },
    );

    return (
      <Box pr={3}>
        <FormLabel>{label}</FormLabel>
        <ToggleButtonGroup
          role='radiogroup'
          aria-label={name}
          orientation={stacking}
          size='small'
          color='primary'
          onChange={onChange}
        >
          {newChildren}
        </ToggleButtonGroup>
      </Box>
    );
  }
}

export { ButtonGroup };
